<template>
  <v-list class="main__light_green">
    <v-radio-group
      v-model="value"
      hide-details>
      <v-list-item
        v-for="(item, n) in addresses"
        :key="item.id"
        class="address-item secondary__green_chosen pa-4"
        :class="n != addresses.length - 1 ? 'mb-4' : 'mb-2'">
        <v-list-item-action class="mr-0 ml-2 align-self-start">
          <v-radio
            color="var(--black-color)"
            :value="item.id || item.organizationItId"/>
        </v-list-item-action>
        <v-list-item-content class="pa-3 ">
          <v-list-item-title class="black--text">
            {{ title ? item[title] : '' }}
            <slot
              :item="item"
              name="title"/>
          </v-list-item-title>
          <v-list-item-subtitle class="col-7 px-0 pb-0 pt-2">
            {{ subtitle ? item[subtitle] : '' }}
            <slot
              :item="item"
              name="subtitle"/>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-radio-group>
  </v-list>
</template>
<script>
export default {
  name: 'adressesRadioList',
  props: {
    subtitle: String,
    title: String,
    addresses: Array,
    model: [Object, String, Boolean, Number]
  },
  computed: {
    value: {
      get() {
        return this.model
      },
      set(value) {
        this.$emit('update:model', value)
      }
    },
  },
}
</script>
